import { AuthService } from 'src/app/services/auth.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': '',
  })
};

@Injectable({
  providedIn: 'root'
})
export class FeatureService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': '',
    })
  };
  private apiUrl: string;
  private userSub;
  private userData: any = {};
  entity_id: any;

  constructor(private http: HttpClient, private _authService: AuthService) {
    const BASE_API_URL = environment.ApiConfig.student;
    this.apiUrl = `${BASE_API_URL}`;
    this.userSub = sessionStorage.getItem('userSub')
    this.entity_id = environment.entity_id;
    // this._authService.getUserDetails().then(data => {
    //   this.httpOptions = {
    //     headers: new HttpHeaders({
    //       'Content-Type': 'application/json',
    //       'Authorization': data.user.signInUserSession.idToken.jwtToken,
    //     })
    //   };
    //   this.userSub = data.user.attributes.sub;
    //   //this.http.options(this.httpOptions);


    // })
  }

  private guardExecuted = false;

  setGuardExecuted(): void {
    this.guardExecuted = true;
  }

  getGuardExecuted(): boolean {
    return this.guardExecuted;
  }

  resetGuardExecuted(): void {
    this.guardExecuted = false;
  }

  //GET
  getFeatureDetails() {
    let entity_id = environment.entity_id
    if (sessionStorage.getItem('userSub'))
      this.userSub = sessionStorage.getItem('userSub');
    return this.http.get(`${this.apiUrl}/student/features/${this.userSub}?entity_id=${entity_id}`, httpOptions);
  }

  getUserPlan() {
    if (sessionStorage.getItem('userSub'))
      this.userSub = sessionStorage.getItem('userSub');
    // return this.http.get('https://cfp68ms7s8.execute-api.ap-south-1.amazonaws.com/dev/student/subscribed-plan/1c0aadf7-c7e2-4641-bfa2-3f0a4fb642a0', httpOptions);
    return this.http.get(`${this.apiUrl}/student/subscribed-plan/${this.userSub}`, httpOptions);
  }

  getAllPlans() {
    let entity_id = environment.entity_id
    return this.http.get(`${this.apiUrl}/student/subscription-plans?entity_id=${entity_id}`, httpOptions);
  }

  checkActiveSession(): Observable<any> {
    if (sessionStorage.getItem('userSub')) {
      const userSub = sessionStorage.getItem('userSub');
      return this.http.get(`${this.apiUrl}/student/assesment/session?uuid=${userSub}`);
    }
    // Handle the case where userSub is not available.
    return of(null);
  }

  async updateSession(check: string): Promise<any> {
    if (sessionStorage.getItem('userSub')) {
      const userSub = sessionStorage.getItem('userSub');
      const userData = { uuid: userSub, session: check };
      return this.http.patch(`${this.apiUrl}/student/assesment/session`, userData).toPromise();
    }
    // Handle the case where userSub is not available.
    return Promise.resolve(null);
  }

  deleteActiveSession() {
    if (sessionStorage.getItem('userSub')) {
      const userSub = sessionStorage.getItem('userSub');
      const deviceId = sessionStorage.getItem('deviceId');
      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': '',
        }),
        body: { uuid: userSub, session_id: deviceId },
      };
      return this.http.delete(`${this.apiUrl}/student/assesment/session`, options);
    }
  }

  bookAssessment(): Observable<any> {
    const userSub = sessionStorage.getItem('userSub');
    const userData = { uuid: userSub, entity_id: this.entity_id };
    return this.http.post(`${this.apiUrl}/student/assesment/session`, userData, this.httpOptions);
    // Handle the case where userSub is not available.
  }

  async getUserPlanOnDashboard() {
    if (sessionStorage.getItem('userSub')) {
      this.userSub = sessionStorage.getItem('userSub');
    }
    try {
      const planInfo = await this.http.get(`${this.apiUrl}/student/subscribed-plan/${this.userSub}`, httpOptions).toPromise();
      return planInfo[0];
    } catch (error) {
      console.error('Error fetching user plan:', error);
      throw error;
    }
  }

}
